<div class="carousel-1">
  <div class="carousel-1-container" [style.transform]="transform()">
    @for (image of themeService.image().carousel; track image; let i = $index) {
      <div
        class="carousel-1-item"
        [class.active]="i === currentIndex()"
        >
        <img width="300" class="mx-auto" [src]="image" alt="Imagen {{ i + 1 }}" />
      </div>
    }
  </div>
  <!-- <button class="prev" (click)="prevSlide()">❮</button>
  <button class="next" (click)="nextSlide()">❯</button> -->
  <div class="indicators">
    @for (image of themeService.image().carousel; track image; let i = $index) {
      <svg
        class=""
        width="20"
        height="32"
        viewBox="0 0 74 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        (click)="goToSlide(i)"
        >
        <g filter="url(#filter0_d_1014_10618)">
          <circle
            cx="20"
            cy="20"
            r="12"
            class="indicator icon-basic"
            [ngClass]="{ active: i === currentIndex() }"
            />
          </g>
        </svg>
      }
    </div>

    <div class="carousel-1-container" [style.transform]="transform()">
      @for (image of themeService.image().carousel; track image; let i = $index) {
        <div
          class="carousel-1-item"
          [class.active]="i === currentIndex()"
          >
          <div class="row justify-content-center mt-5">
            <div class="col text-center text-basic">
              <h4 class="presentation-title-size">
                {{ textPresentations[i].lowerTitle | translate }}
              </h4>
              <p class="presentation-color-bottom px-lg-3 px-xl-5">
                <small>
                  {{ textPresentations[i].bottomStoryText | translate }}
                </small>
              </p>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
